<template>
  <div>
    <ActionBar />
    <DataTable
      :icon="icon"
      :items="items"
      :headers="headers"
      :sortBy="sortBy"
      :showItem="showItem"
      :loading="!fullyLoaded"
    />
  </div>
</template>

<script>
import Toastable from '@/mixins/toastable';
import AsyncComputable from '@/mixins/asyncComputable';

export default {
  mixins: [Toastable, AsyncComputable],
  components: {
    DataTable: () => import('@/components/core/DataTable.vue'),
  },
  asyncComputed: {
    items: {
      get() {
        return this.resourceService.index(this.resourceParams).then((items) => {
          return items.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
  computed: {
    siteId() {
      return this.$route.params.site_id;
    },
    destination() {
      return `/sites/${this.siteId}/${this.urlFragment}`;
    },
  },
  methods: {
    showItem(item) {
      this.$router.push(`${this.destination}/${item.id}`);
    },
  },
};
</script>
